module.exports = "/images/hy.svg";